import { createSlice } from "@reduxjs/toolkit";
import Api from "../../lib/api";

export const initialState = {
  loading: false,
  errors: [],
  models: [],
};

const ModelsSlice = createSlice({
  name: "Models",
  initialState,
  reducers: {
    getModels: (state) => {
      state.loading = true;
    },
    getModelsSuccess: (state, { payload }) => {
      state.models = payload.data;
      state.loading = false;
      state.errors = [];
    },
    getModelsFailure: (state, { payload }) => {
      state.loading = false;
      state.errors = [...state.errors, payload.message];
    },
  },
});

export const {
  getModels,
  getModelsSuccess,
  getModelsFailure,
} = ModelsSlice.actions;
export const ModelsSelector = (state) => state.models;
export default ModelsSlice.reducer;

export function fetchModelsService() {
  return async (dispatch) => {
    dispatch(getModels());

    try {
      const response = await Api.getModels();

      dispatch(getModelsSuccess(response.data));
    } catch (error) {
      dispatch(getModelsFailure(error));
    }
  };
}
